import * as React from "react";
import { useContext } from "react";
import { Form } from "semantic-ui-react";
import { QAPropsBase } from "../State";
import { changeFn, store } from "../store";

// tslint:disable-next-line: interface-name
interface Props {
    index: number;
    propsBase: QAPropsBase;
    onChange?: changeFn;
}

const RadioAnswer: React.FunctionComponent<Props> = (props: Props) => {
  const globalState = useContext(store);
  const { dispatch } = globalState;

  return (
      <div>
        {
          <Form.Group required grouped>
          {props.propsBase.answerContent.split(";").map((a) => {
              return <Form.Input inline type="radio" key={`${props.index}_${a}`} id={`${props.index}_${a}`}
                  // tslint:disable-next-line: max-line-length
                  onChange={(e, d) => props.onChange ? props.onChange(e, props.index, d) :
                      dispatch({
                          type: "handle answer update",
                          index: props.index,
                          value: d.value, validator: props.propsBase.answerValidator
                      })
                  }
                  checked={props.propsBase.answerValue === a} value={a} label={a}
                  labelPosition={"left"} />;
          })}
          </Form.Group>
        }
      </div>
    );
  };

export default RadioAnswer;
